import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { editRol, getRolByRealEstate } from 'redux/rolesSlice';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonSuccessSubmit from 'utils/buttons/ButtonSuccessSubmit';
import Permisos from './components/Permisos';
import PropTypes from 'prop-types';
// import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import AlternativeModalButtonsContainer from 'sites/common/AlternativeModalButtonsContainer';

const EditRol = ({ show, setShow, realEstate, listaRoles }) => {
  const dispatch = useDispatch();

  const tablaPermisos = useSelector(state => state.permisos.data);

  const [errors, setErrors] = useState({
    errorFound: false,
    alert: null
  });
  const initialList = {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
    12: false,
    13: false,
    14: false,
    15: false,
    16: false,
    17: false,
    18: false,
    19: false,
    20: false
  };
  const [rolEdit, setRolEdit] = useState({
    id: '',
    inmobiliaria: '',
    nombre: '',
    permisos: { ...initialList }
  });

  useEffect(() => {
    if (listaRoles?.length > 0 && show) {
      const rolData = listaRoles.filter(rol => rol.id === Number(show));

      const list = { ...initialList };
      rolData[0]?.roleToPermission?.map(permKey => {
        list[permKey.permission.id] = true;
      });
      setRolEdit({
        id: rolData[0]?.id,
        inmobiliaria: realEstate.id,
        nombre: rolData[0]?.name,
        permisos: { ...list }
      });
    }
  }, [listaRoles, show]);

  const handleSwitchEdit = e => {
    setRolEdit({
      ...rolEdit,
      permisos: {
        ...rolEdit.permisos,
        [e.target.id]: !rolEdit.permisos[e.target.id]
      }
    });
  };

  useEffect(() => {
    if (rolEdit.nombre?.length < 2) {
      setErrors({
        errorFound: true,
        alert: 'Ingrese un nombre con mínimo 2 letras.'
      });
    } else if (
      listaRoles &&
      listaRoles.some(
        element => element.name === rolEdit.nombre && element.id !== rolEdit.id
      )
    ) {
      setErrors({
        errorFound: true,
        alert: 'El nombre ingresado ya está en uso.'
      });
    } else {
      setErrors({
        errorFound: false,
        alert: null
      });
    }
  }, [rolEdit.nombre]);

  const handleEdit = async e => {
    e.preventDefault();
    try {
      if (!errors.errorFound) {
        await dispatch(editRol(rolEdit));
        setRolEdit({
          nombre: '',
          inmobiliaria: '',
          id: '',
          permisos: {}
        });
        await dispatch(getRolByRealEstate(realEstate.id));

        setShow(false);
      }
    } catch (e) {
      console.log(e);
      return e;
    }
  };

  const handleCancel = async e => {
    try {
      e.preventDefault();

      setRolEdit({
        nombre: '',
        inmobiliaria: '',
        id: '',
        permisos: {}
      });
      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header>
        <Modal.Title>Editar rol</Modal.Title>
      </Modal.Header>

      <Form
        className="d-flex flex-column justify-content-start"
        onSubmit={handleEdit}
      >
        <Modal.Body>
          <Row className="gap-3">
            <Form.Group as={Col} xs={12}>
              <Form.Label className="fs-0">Nombre</Form.Label>

              <Form.Control
                size="sm"
                className="py-0"
                type="text"
                value={rolEdit.nombre}
                onChange={e =>
                  setRolEdit({ ...rolEdit, nombre: e.target.value })
                }
                style={{ width: 'fit-content' }}
                isInvalid={errors.errorFound}
              />

              <Form.Control.Feedback type="invalid">
                {errors.alert}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12}>
              <Form.Label className="fs-0">Seleccionar permisos</Form.Label>

              <Row className="g-3">
                {tablaPermisos.map(({ name, permissions }, index) => (
                  <Col key={index} xs={12} sm={6}>
                    <Permisos
                      rol={rolEdit}
                      name={name}
                      permissions={permissions}
                      handleSwitch={handleSwitchEdit}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <AlternativeModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleCancel}
              variant="secondary"
            />

            <ButtonSuccessSubmit
              text="Guardar"
              disabled={
                errors.errorFound ||
                Object.keys(rolEdit.permisos).filter(p => rolEdit.permisos[p])
                  .length < 1
              }
            />
          </AlternativeModalButtonsContainer>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

EditRol.propTypes = {
  show: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  setShow: PropTypes.func.isRequired,
  realEstate: PropTypes.object,
  listaRoles: PropTypes.array.isRequired
};

export default EditRol;
